// extracted by mini-css-extract-plugin
module.exports = {"active":"sidenavitem_active__3vq46","icon":"sidenavitem_icon__24DyD","label":"sidenavitem_label__1cHpc"};